export function Toggle({
  checked, onChange, label, disabled,
}: { checked: boolean; onChange: (v: boolean) => void; label?: string; disabled?: boolean }) {
  return (
    <label className={`inline-flex items-center gap-2.5 ${disabled ? 'opacity-60' : 'cursor-pointer'}`}>
      {/*
        `shrink-0` là bắt buộc, không phải trang trí: núm là con DUY NHẤT của button và nó
        `absolute`, nên min-content của button bằng 0 ⇒ trong ô bảng chật (cột "Trên web" của
        ProductList, cột cuối của VariantsEditor) track co về gần 0 trong khi núm vẫn dịch
        20px ⇒ núm rơi ra ngoài track, đè lên nhãn. Toạ độ ngang khai tường minh bằng
        `left-0.5` + `translate-x-0/5` để không phụ thuộc static position của phần tử absolute.
        Track 44×24 · núm 20 · chừa 2px mỗi bên.
      */}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-150 ${checked ? 'bg-primary-700' : 'bg-border-strong'}`}
      >
        <span className={`absolute left-0.5 top-0.5 size-5 rounded-full bg-white shadow transition-transform duration-150 ${checked ? 'translate-x-5' : 'translate-x-0'}`} />
      </button>
      {label && <span className="text-sm text-ink">{label}</span>}
    </label>
  )
}
